// Central Phase 1 configuration for Nofina Movie (frontend-only).

// Production WhatsApp destination (international format, digits only).
export const WHATSAPP_NUMBER = "6281390001710";

// Optional announcement bar. Leave empty string to hide the bar entirely.
export const ANNOUNCEMENT = "";

export const BRAND = {
  name: "Nofina Movie",
  description:
    "Toko langganan digital yang praktis dan transparan. Pilih platform, tentukan paket, lalu pesan lewat WhatsApp.",
};

export const NAV_LINKS = [
  { label: "Beranda", to: "/" },
  { label: "Katalog", to: "/produk" },
  { label: "Cara Beli", to: "/cara-beli" },
  { label: "Bantuan", to: "/bantuan" },
];

export const FOOTER_MAIN_LINKS = [
  { label: "Beranda", to: "/" },
  { label: "Katalog Produk", to: "/produk" },
  { label: "Cara Beli", to: "/cara-beli" },
  { label: "Bantuan/FAQ", to: "/bantuan" },
];

export const FOOTER_POLICY_LINKS = [
  { label: "Tentang", to: "/tentang" },
  { label: "Ketentuan Layanan", to: "/ketentuan" },
  { label: "Kebijakan Privasi", to: "/privasi" },
  { label: "Ketentuan Garansi", to: "/garansi" },
];
